import React from 'react';
import { Button} from 'react-bootstrap';
import { useToast } from '../../../hooks/useToast';



const DownloadFileComponent = (props) => {

    const { path, message = null, icon = false, variant = "primary", as = null, bsPrefix = null } = props;
    const toast = useToast();

    const openIfExists = async (url) => {
        try {
            const res = await fetch(url, { method: 'HEAD' });
            if (res.ok) {
                window.open(url, '_blank');
            } else {
                toast.open({ message: "Le fichier est introuvable", variant: "danger" });
            }
        } catch (err) {
            toast.open({ message: "Le téléchargement du fichier a échoué", variant: "danger" });
        }
    }

    const onDownloadFile = () => {
        openIfExists(path);
    }

    return <Button variant={variant} as={as} bsPrefix={bsPrefix} onClick={onDownloadFile}>
        {icon ?
            <i className="fas fa-download"></i>
            : null
        }
        {message && icon ? " " : null}
        {message ?? null}
    </Button>;
}

export default DownloadFileComponent;